class FaqProducts extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faq-products__item'));
    this.triggers = Array.from(this.querySelectorAll('.faq-products__trigger'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggle(trigger));
      trigger.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  toggle(trigger) {
    const item = trigger.closest('.faq-products__item');
    const willOpen = !item.classList.contains('is-open');

    this.items.forEach((other) => {
      const otherTrigger = other.querySelector('.faq-products__trigger');
      other.classList.remove('is-open');
      otherTrigger.setAttribute('aria-expanded', 'false');
    });

    if (willOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  onKeydown(event) {
    const index = this.triggers.indexOf(event.target);
    if (index < 0) return;

    let nextIndex = null;

    switch (event.key) {
      case 'ArrowDown':
        nextIndex = (index + 1) % this.triggers.length;
        break;
      case 'ArrowUp':
        nextIndex = (index - 1 + this.triggers.length) % this.triggers.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.triggers.length - 1;
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.toggle(event.target);
        return;
      default:
        return;
    }

    event.preventDefault();
    this.triggers[nextIndex].focus();
  }
}

if (!customElements.get('faq-products')) {
  customElements.define('faq-products', FaqProducts);
}
